import { Box, Fade, IconButton, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { IPortalNotifications } from "src/@types/notifications/portalNotifications";
import ChevronLeftIcon from "src/assets/icon/chevron/left";
import ChevronRightIcon from "src/assets/icon/chevron/right";
import { GetAsync } from "src/common/httpRequests";
import { API_GATEWAY } from "src/constants/settings";
import { useBanner } from "src/contexts/BannerContext";
import useInterval from "src/hooks/useInterval";
import useLocales from "src/hooks/useLocales";

export default function TopBanner() {
  const theme = useTheme();
  const { translate } = useLocales();
  const [notifications, setNotifications] = useState<
    null | IPortalNotifications[]
  >(null);
  const { setVisible, setHasNewVersion, setHasUnClassifiedDoc } = useBanner();
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleCount = 1;

  function fetchPortalNotifications(mounted = true) {
    GetAsync(
      `${API_GATEWAY}/api/notificationservice/Notifications/portal`,
    ).then((res) => {
      if (!mounted) return;

      if (res.status === 200) {
        setHasUnClassifiedDoc(res?.data?.hasUnClassifiedDoc);
        const currentVersion = localStorage.getItem("version");
        const latestVersion = res?.data?.version;
        if (latestVersion) {
          if (!currentVersion) {
            localStorage.setItem("version", latestVersion);
          } else if (currentVersion !== latestVersion) {
            localStorage.setItem("version", latestVersion);
            localStorage.setItem("hasNewVersion", "true");
            setHasNewVersion(true);
          }
        }
        setNotifications(res.data.notifications);
      }
    });
  }

  useInterval(fetchPortalNotifications, 20000);

  useEffect(() => {
    let mounted = true;

    fetchPortalNotifications(mounted);

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    setVisible(!!notifications?.length);
  }, [notifications, setVisible]);

  if (!notifications || notifications.length === 0) {
    return null;
  }

  const nextNotification = () => {
    setCurrentIndex((prev) => (prev + 1) % notifications!.length);
  };

  const prevNotification = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? notifications!.length - 1 : prev - 1,
    );
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: 40,
        backgroundColor: theme.palette.warning.main,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1,
        boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
        px: 2,
      }}
    >
      {notifications
        ?.slice(currentIndex, currentIndex + visibleCount)
        .map((notification, i) => (
          <Fade
            key={currentIndex} // triggers animation on change
            in={true} // always true to show the element
            mountOnEnter
            unmountOnExit
          >
            <Typography
              variant="subtitle2"
              sx={{
                mx: 1,
                fontWeight: 600,
                // width: "400px", // fixed width
                // overflow: "hidden", // hide overflowing text
                // textOverflow: "ellipsis", // show "..." if text too long
                whiteSpace: "nowrap",
                textAlign: "center",
              }}
              component="span"
            >
              {translate(
                notifications[currentIndex].message,
                notifications[currentIndex].values,
              )}
            </Typography>
          </Fade>
        ))}
      {notifications && notifications?.length > 1 ? (
        <>
          <IconButton onClick={prevNotification}>
            <ChevronLeftIcon color="#fff" height={16} width={16} />
          </IconButton>
          <IconButton onClick={nextNotification}>
            <ChevronRightIcon color="#fff" height={16} width={16} />
          </IconButton>
        </>
      ) : null}
    </Box>
  );
}
